import { Link } from 'react-router-dom'
import { LockIcon } from '@shared/ui'
import { ICON_HEIGHT, type MenuItem } from './menuItems'

interface BottomMenuItemProps {
  item: MenuItem
  isActive: boolean
  /** Раздел закрыт подпиской: ведём не внутрь, а на её оформление. */
  isLocked: boolean
  lockedTo: string
}

/** Пункт нижнего меню: иконка маской, подпись и замок у закрытых разделов. */
export const BottomMenuItem = ({
  item,
  isActive,
  isLocked,
  lockedTo,
}: BottomMenuItemProps) => (
  <Link
    to={isLocked ? lockedTo : item.path}
    className={`bottom-menu-item ${isActive ? 'active' : ''} ${isLocked ? 'locked' : ''}`}
    onClick={event => {
      // Тап по разделу, в котором уже находишься, возвращает наверх. Переход
      // при этом не нужен: роутер на тот же адрес ничего не перерисует, а
      // страница осталась бы прокрученной.
      if (!isActive || isLocked) return
      event.preventDefault()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }}
  >
    <span className="bottom-menu-icon-box">
      <span
        className="bottom-menu-icon"
        style={{
          width: item.width,
          height: ICON_HEIGHT,
          // Кавычки обязательны: Vite инлайнит SVG в data-URI, внутри
          // которого остаются апострофы (fill='%23666666'). Без кавычек
          // это невалидный url-токен — WebKit его отбрасывает и вместо
          // иконки остаётся залитый прямоугольник.
          maskImage: `url("${item.icon}")`,
          WebkitMaskImage: `url("${item.icon}")`,
          // Наклон отдаём в CSS переменной, а не в transform: иначе
          // инлайновый стиль перебил бы анимацию нажатия.
          '--icon-rotate': `${item.rotate ?? 0}deg`,
        } as React.CSSProperties}
        aria-hidden
      />
      {isLocked && (
        <span className="bottom-menu-lock" aria-hidden>
          <LockIcon />
        </span>
      )}
    </span>
    <span className="bottom-menu-label">{item.label}</span>
  </Link>
)
